export const OPTICAL_PROCEDURE_COPYWRITING_KEY = 'optical_procedure_copywriting' as const;

export const OPTICAL_PROCEDURE_TITLE_KEYS = [
  'prescription_type',
  'readers_prescription',
  'prescription_methods',
  'enter_prescription',
  'prescription_recognition',
  'my_prescription',
  'lens_type',
  'lens_index',
  'view_area',
  'coating',
  'recommended',
] as const;
